import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';

import React, { useCallback, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createAccount } from '../../api/auth';

export default function CreateAccountForm() {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);
  const formData = useRef({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
  });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email, password, lastName, firstName } = formData.current;
      setLoading(true);

      const userData = { lastName, firstName, email, password };
      const result = await createAccount(userData);
      setLoading(false);

      if (result.isOk) {
        setNotification({
          open: true,
          message: result.message,
          severity: 'success',
        });

        navigate('/login');
      } else {
        setNotification({
          open: true,
          message: result.message,
          severity: 'error',
        });
      }
    },
    [navigate]
  );

  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 430, margin: '10% auto' }}>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant='filled'
        >
          {notification.message}
        </Alert>
      </Snackbar>
      <form onSubmit={onSubmit}>
        <Typography variant='h5' textAlign='center' gutterBottom>
          Új fiók létrehozása
        </Typography>
        <TextField
          fullWidth
          label='Vezetéknév'
          variant='filled'
          required
          onChange={(e) => (formData.current.lastName = e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label='Keresztnév'
          variant='filled'
          required
          onChange={(e) => (formData.current.firstName = e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label='E-mail cím'
          variant='filled'
          type='email'
          required
          onChange={(e) => (formData.current.email = e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label='Jelszó'
          variant='filled'
          type='password'
          required
          onChange={(e) => (formData.current.password = e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label='Jelszó megerősítése'
          variant='filled'
          type='password'
          required
          sx={{ mb: 2 }}
        />

        <FormControlLabel
          control={
            <Checkbox checked={agree} onChange={() => setAgree(!agree)} />
          }
          label={
            <Typography variant='body2'>
              A fiók létrehozásával az <Link to='/aszf'>ÁSZF</Link> és az{' '}
              <Link to='/gdpr'>Adatvédelmi Tájékoztatót</Link> elfogadom.
            </Typography>
          }
        />

        <Box textAlign='center' mt={2}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
            disabled={!agree || loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Új fiók létrehozása'}
          </Button>
        </Box>

        <Typography variant='body2' textAlign='center' mt={2}>
          Már van fiókja? <Link to='/login'>Lépjen be</Link>
        </Typography>
      </form>
    </Paper>
  );
}
